import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton, Stack,
    Divider,
    TextField,
    Typography, ThemeProvider, Slider, Box, Switch, Skeleton
} from "@mui/material";
import Button from "@mui/material/Button";
import React, {useEffect, useState} from "react";
import CloseIcon from "@mui/icons-material/Close";
import {MuiColorInput} from 'mui-color-input'
import Collapsable from "./Collapsable";
import * as d3 from "d3";
import {getCurrentUrl} from "./Globals";
const CombinedViewDialog = (props) => {

    return (
        <Dialog
            open={props.openCondition}
            onClose={e => props.setOpenCondition(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Large graph warning"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="warning" variant="contained" onClick={e => {
                    props.drawCombined.current = true;
                    props.setTriggerDraw(!props.triggerDraw)
                    props.setOpenCondition(false);
                }

                }>Display</Button>
                <Button color="primary" variant="contained" onClick={e => {
                    props.setOpenCondition(false);
                    props.setSelectedTab('social');
                }} autoFocus>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}
const LargeGraphDialog = (props) => {

    return (
        <Dialog
            open={props.openCondition}
            onClose={e => props.setOpenCondition(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Large graph warning"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="warning" variant="contained" onClick={e => {
                    props.setDrawGraph(true);
                    props.setOpenCondition(false);
                }

                }>Display</Button>
                <Button color="primary" variant="contained" onClick={props.handleExport} autoFocus>
                    Export GR/CO
                </Button>
            </DialogActions>
        </Dialog>
    );
}
const AlertDialog = (props) => {

    return (
        <Dialog
            open={props.openConfirm}
            onClose={e => props.setOpenConfirm(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Are you sure you want to open a new project?"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button sx={{color: '#aaa'}} variant="outlined"
                        onClick={e => props.setOpenConfirm(false)}>Cancel</Button>
                <Button color="warning" variant="contained" onClick={props.onAccept} autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}
const InformationDialog = (props) => {

    return (
        <Dialog
            open={props.openInformation}
            onClose={e => props.setOpenInformation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="success" variant="contained" onClick={e => props.setOpenInformation(false)} autoFocus>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const SettingsDialog = (props) => {

    const [currentStandardNodeColor, setCurrentStandardNodeColor] = useState('#ffffff');
    const [currentHighlightNodeColor, setCurrentHighlightNodeColor] = useState('#ffffff');
    const [currentStandardEdgeColor, setCurrentStandardEdgeColor] = useState('#ffffff');
    const [currentHighlightEdgeColor, setCurrentHighlightEdgeColor] = useState('#ffffff');
    const [currentNodeRadius, setCurrentNodeRadius] = useState(0);
    const [currentEdgeWidth, setCurrentEdgeWidth] = useState(0);
    const [nodeLabelColor, setNodeLabelColor] = useState('#ffffff');
    const [edgeLabelColor, setEdgeLabelColor] = useState('#ffffff');
    const [currentPrimaryColor, setCurrentPrimaryColor] = useState(props.theme.palette.primary.main);
    const [currentSecondaryColor, setCurrentSecondaryColor] = useState(props.theme.palette.secondary.main);
    const [edgeSettingsAdvanced, setEdgeSettingsAdvanced] = useState(false);
    const [edgeSettingsSocialSocial, setEdgeSettingsSocialSocial] = useState(props.theme.palette.primary.main);
    const [edgeSettingsSocialSpatial, setEdgeSettingsSocialSpatial] = useState(props.theme.palette.primary.main);
    const [nodeSettingsSpatial, setNodeSettingsSpatial] = useState('#000000');
    const [nodeSettingsSocial, setNodeSettingsSocial] = useState('#000000');
    const [nodeSettingsAdvanced, setNodeSettingsAdvanced] = useState(false);
    useEffect(() => {
        if (props.openSettingsDialog) {
            setCurrentStandardNodeColor(props.standardNodeColor);
            setCurrentHighlightNodeColor(props.highlightNodeColor);
            setCurrentStandardEdgeColor(props.standardEdgeColor);
            setCurrentHighlightEdgeColor(props.highlightEdgeColor);
            setCurrentNodeRadius(props.nodeRadius);
            setCurrentEdgeWidth(props.edgeWidth);
            setNodeLabelColor(props.nodeLabelColor);
            setEdgeLabelColor(props.edgeLabelColor);
            setCurrentPrimaryColor(props.primaryColor);
            setCurrentSecondaryColor(props.secondaryColor);
            setEdgeSettingsAdvanced(props.edgeSettingsAdvanced);
            setEdgeSettingsSocialSocial(props.edgeSettingsSocialSocial);
            setEdgeSettingsSocialSpatial(props.edgeSettingsSocialSpatial);
            setNodeSettingsSocial(props.nodeSettingsSocial);
            setNodeSettingsSpatial(props.nodeSettingsSpatial);
            setNodeSettingsAdvanced(props.nodeSettingsAdvanced);
        }
    }, [props.openSettingsDialog])
    return (
        <ThemeProvider theme={props.theme}>
            <Dialog
                onClose={e => props.setOpenSettingsDialog(false)}
                aria-labelledby="customized-dialog-title"
                open={props.openSettingsDialog}
                fullwidth="true"
                maxWidth="lg"
            >
                <DialogTitle sx={{m: 0, p: 2}} id="customized-dialog-title">
                    View Settings
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={e => props.setOpenSettingsDialog(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent dividers>
                    <Collapsable title="General settings" openInitial={true}>
                        <Stack
                            direction="column"
                            divider={<Divider orientation="horizontal" flexItem/>}
                            spacing={1}>
                            <div className="flex flex-row items-center justify-between">
                                <Typography variant="settingsText">Primary accent color </Typography>
                                <MuiColorInput sx={{ml: 20}}
                                               format="hex"
                                               value={currentPrimaryColor}
                                               onChange={color => setCurrentPrimaryColor(color)}
                                               size="small">
                                </MuiColorInput>
                            </div>
                            <div className="flex flex-row items-center justify-between">
                                <Typography variant="settingsText">Secondary accent color </Typography>
                                <MuiColorInput sx={{ml: 20}}
                                               format="hex"
                                               value={currentSecondaryColor}
                                               onChange={color => setCurrentSecondaryColor(color)}
                                               size="small">
                                </MuiColorInput>
                            </div>
                        </Stack>
                    </Collapsable>
                    <Collapsable title="Node settings" openInitial={true}>
                        <Stack
                            direction="column"
                            divider={<Divider orientation="horizontal" flexItem/>}
                            spacing={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="settingsText" sx={{color: '#FFFFFF'}}>Simple</Typography>
                                <Switch checked={nodeSettingsAdvanced}
                                        onChange={e => setNodeSettingsAdvanced(!nodeSettingsAdvanced)}/>
                                <Typography variant="settingsText" sx={{color: '#FFFFFF'}}>Advanced</Typography>
                            </Stack>
                            {!nodeSettingsAdvanced &&
                                <div className="flex flex-row items-center justify-between">
                                    <Typography variant="settingsText">Node color </Typography>
                                    <MuiColorInput sx={{ml: 20}}
                                                   format="hex"
                                                   value={currentStandardNodeColor}
                                                   onChange={color => setCurrentStandardNodeColor(color)}
                                                   size="small">
                                    </MuiColorInput>
                                </div>
                            }
                            {
                                nodeSettingsAdvanced &&
                                <Stack
                                    direction="column"
                                    divider={<Divider orientation="horizontal" flexItem/>}
                                    spacing={1}>
                                    <div className="flex flex-row items-center justify-between my-2">
                                        <Typography variant="settingsText">Social node color</Typography>
                                        <MuiColorInput sx={{ml: 20}}
                                                       format="hex"
                                                       value={nodeSettingsSocial}
                                                       onChange={color => setNodeSettingsSocial(color)}
                                                       size="small"/>
                                    </div>
                                    <div className="flex flex-row items-center justify-between">
                                        <Typography variant="settingsText">Spatial node color</Typography>
                                        <MuiColorInput sx={{ml: 20}}
                                                       format="hex"
                                                       value={nodeSettingsSpatial}
                                                       onChange={color => setNodeSettingsSpatial(color)}
                                                       size="small"/>
                                    </div>
                                </Stack>
                            }
                            <div className="flex flex-row items-center justify-between">
                                <Typography variant="settingsText">Highlight node color</Typography>
                                <MuiColorInput
                                    sx={{ml: 20}} format="hex" value={currentHighlightNodeColor}
                                    onChange={color => setCurrentHighlightNodeColor(color)}
                                    size="small"/>
                            </div>

                            <div className="flex flex-row items-center justify-between">
                                <Typography variant="settingsText">Node radius</Typography>
                                <Box sx={{width: 300}}>
                                    <Slider
                                        size="small"
                                        min={5}
                                        max={50}
                                        valueLabelDisplay="auto"
                                        value={currentNodeRadius}
                                        aria-label="Custom marks"
                                        defaultValue={10}
                                        step={1}
                                        onChange={e => setCurrentNodeRadius(e.target.value)}
                                    />
                                </Box>
                            </div>
                            <div className="flex flex-row items-center justify-between">
                                <Typography variant="settingsText">Node label color</Typography>
                                <MuiColorInput
                                    sx={{ml: 20}} format="hex" value={nodeLabelColor}
                                    onChange={color => setNodeLabelColor(color)}
                                    size="small"/>
                            </div>
                        </Stack>
                    </Collapsable>
                    <Collapsable title="Edge settings" openInitial={true}>
                        <Stack
                            direction="column"
                            divider={<Divider orientation="horizontal" flexItem/>}
                            spacing={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="settingsText" sx={{color: '#FFFFFF'}}>Simple</Typography>
                                <Switch checked={edgeSettingsAdvanced}
                                        onChange={e => setEdgeSettingsAdvanced(!edgeSettingsAdvanced)}/>
                                <Typography variant="settingsText" sx={{color: '#FFFFFF'}}>Advanced</Typography>
                            </Stack>
                            {!edgeSettingsAdvanced &&
                                <div className="flex flex-row items-center justify-between">
                                    <Typography variant="settingsText">Edge color</Typography>
                                    <MuiColorInput sx={{ml: 20}}
                                                   format="hex"
                                                   value={currentStandardEdgeColor}
                                                   onChange={color => setCurrentStandardEdgeColor(color)}
                                                   size="small"/>
                                </div>
                            }
                            {
                                edgeSettingsAdvanced &&
                                <Stack
                                    direction="column"
                                    divider={<Divider orientation="horizontal" flexItem/>}
                                    spacing={1}>
                                    <div className="flex flex-row items-center justify-between my-2">
                                        <Typography variant="settingsText">Social - Social edge color</Typography>
                                        <MuiColorInput sx={{ml: 20}}
                                                       format="hex"
                                                       value={edgeSettingsSocialSocial}
                                                       onChange={color => setEdgeSettingsSocialSocial(color)}
                                                       size="small"/>
                                    </div>
                                    <div className="flex flex-row items-center justify-between">
                                        <Typography variant="settingsText">Social - Spatial edge color</Typography>
                                        <MuiColorInput sx={{ml: 20}}
                                                       format="hex"
                                                       value={edgeSettingsSocialSpatial}
                                                       onChange={color => setEdgeSettingsSocialSpatial(color)}
                                                       size="small"/>
                                    </div>
                                </Stack>
                            }
                            <div className="flex flex-row items-center justify-between">
                                <Typography variant="settingsText">Highlight edge color</Typography> <MuiColorInput
                                sx={{ml: 20}} format="hex" value={currentHighlightEdgeColor}
                                onChange={color => setCurrentHighlightEdgeColor(color)} size="small"/>
                            </div>
                            <div className="flex flex-row items-center justify-between">
                                <Typography variant="settingsText">Edge width</Typography>
                                <Box sx={{width: 300}}>
                                    <Slider
                                        size="small"
                                        min={5}
                                        max={50}
                                        valueLabelDisplay="auto"
                                        value={currentEdgeWidth}
                                        aria-label="Custom marks"
                                        defaultValue={10}
                                        step={1}
                                        onChange={e => setCurrentEdgeWidth(e.target.value)}
                                    />
                                </Box>
                            </div>
                            <div className="flex flex-row items-center justify-between">
                                <Typography variant="settingsText">Edge label color</Typography>
                                <MuiColorInput
                                    sx={{ml: 20}} format="hex" value={edgeLabelColor}
                                    onChange={color => setEdgeLabelColor(color)}
                                    size="small"/>
                            </div>
                        </Stack>
                    </Collapsable>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={e => props.saveUserSettings(currentStandardNodeColor,
                        currentHighlightNodeColor, currentStandardEdgeColor, currentHighlightEdgeColor,
                        currentNodeRadius, currentEdgeWidth, nodeLabelColor, edgeLabelColor, currentPrimaryColor, currentSecondaryColor,
                        edgeSettingsSocialSocial, edgeSettingsSocialSpatial, edgeSettingsAdvanced,
                        nodeSettingsSocial, nodeSettingsSpatial, nodeSettingsAdvanced)}>
                        Save changes
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    )
}
const StatsDialog = (props) => {
    const [averageDegree, setAverageDegree] = useState(0);
    const [maxDegree, setMaxDegree] = useState(0);
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState({
        "highestDegree": 0,
        "averageDegree": 0,
        "diameter": 0,
        "numTriangles": 0,
        "stdDev": 0,
    });
    const labelText = {
        "highestDegree": "Highest degree",
        "averageDegree": "Average degree",
        "diameter": "Diameter",
        "numTriangles": "Number of triangles",
        "stdDev": "Standard deviation of degree",
    }
    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(`${getCurrentUrl()}:5000/generate_statistics`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "nodes": props.jsonData?.nodes,
                    "edges": props.jsonData?.links,
                })
            });

            const data = await response.json();
            setStats(data.result);
            return data;
        }
        if (props.openStatsDialog) {
            setLoading(true);
            fetchData().then(fetchData => {
                setLoading(false);
                const data = fetchData?.result?.degrees
                debugger
                let margin = {top: 10, right: 30, bottom: 30, left: 40};
                let width = 460 - margin.left - margin.right;
                let height = 400 - margin.top - margin.bottom;

                var svg = d3.select("#histo")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform",
                        "translate(" + margin.left + "," + margin.top + ")");
                debugger
                let max = d3.max(data, d => d);
                let min = d3.min(data, d => d);
                var x = d3.scaleLinear()
                    .domain([min, max + 1])
                    .range([0, width]);
                svg.append("g")
                    .attr("transform", "translate(0," + height + ")")
                    .call(d3.axisBottom(x).ticks(max - min + 1));


                var histogram = d3.histogram()
                    .value(function (d) {
                        return d;
                    })
                    .domain(x.domain())
                    .thresholds(x.ticks(new Set(data).size + 1));

                var bins = histogram(data);

                debugger

                var y = d3.scaleLinear()
                    .range([height, 0]);
                y.domain([0, d3.max(bins, function (d) {
                    return d.length;
                })]);
                svg.append("g")
                    .call(d3.axisLeft(y));


                debugger
                svg.selectAll("rect")
                    .data(bins)
                    .enter()
                    .append("rect")
                    .attr("x", 1)
                    .attr("transform", function (d) {
                        return "translate(" + x(d.x0) + "," + y(d.length) + ")";
                    })
                    .attr("width", function (d) {
                        debugger
                        return x(d.x0 + 1) - x(d.x0) - 1;
                    })
                    .attr("height", function (d) {
                        return height - y(d.length);
                    })
                    .style("fill", "#69b3a2")

            });
        }
    }, [props.openStatsDialog]);

    return (

        <Dialog
            open={props.openStatsDialog}
            onClose={e => props.setOpenStatsDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullwidth="true"
            maxWidth="lg"
        >
            <DialogTitle id="alert-dialog-title">
                {"Statistics"}
            </DialogTitle>
            <DialogContent>
                <div className="flex align-center items-center">
                    <div className="my-4">
                        <Typography variant="settingsText" className="my-auto mx-auto text-center">
                            {"Degree histogram"}</Typography>
                        <svg id={"histo"} className="mx-auto my-auto">
                        </svg>
                    </div>
                    <div className="h-96 mr-4 border rounded border-neutral-700 dark:border-neutral-200">

                    </div>
                <Stack
                    direction="column"
                    divider={<Divider orientation="horizontal" flexItem/>}
                    spacing={1}>
                    {
                        Object.keys(stats).map((stat) => {
                            if (stat === 'degrees') return
                            return (
                                <div key={stat} className="flex flex-row items-center justify-between my-2">
                                    <Typography variant="settingsText">{labelText[stat]}</Typography>
                                    {loading ? (<Skeleton variant="text" sx={{ml: 20}} width={230} height={50}/>) : (
                                        <TextField sx={{ml: 20}}
                                                   inputProps={{readOnly: true}}
                                                   value={Math.round(stats[stat] * 100) / 100}
                                                   size="small"/>
                                    )}
                                </div>
                            )

                        })
                    }
                </Stack>

                </div>
            </DialogContent>
            <DialogActions>
                <Button color="success" variant="contained" onClick={e => props.setOpenStatsDialog(false)} autoFocus>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export {AlertDialog, InformationDialog, SettingsDialog, StatsDialog, LargeGraphDialog, CombinedViewDialog};